import { render, staticRenderFns } from "./PhoneGroup.vue?vue&type=template&id=5808c932&scoped=true"
import script from "./PhoneGroup.vue?vue&type=script&lang=js"
export * from "./PhoneGroup.vue?vue&type=script&lang=js"
import style0 from "./PhoneGroup.vue?vue&type=style&index=0&id=5808c932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808c932",
  null
  
)

export default component.exports